import { featuresData } from '@/mocks/homeData';

export default function FeaturesSection() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-2">平台特色</h2>
        <p className="text-sm text-foreground-500 mb-8 md:mb-10">为什么百万吃瓜群众选择51cg吃瓜</p>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {featuresData.map((item, i) => (
            <div key={i} className="bg-background-50 rounded-xl p-5 md:p-6 border border-background-200/60 hover:border-primary-500/20 transition-all group cursor-default">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 mb-4 group-hover:bg-primary-500/20 transition-colors">
                <i className={`${item.icon} text-xl`}></i>
              </div>
              <h3 className="text-base font-medium text-foreground-200 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}